import { useEffect } from "react";
import { getConsent, onConsentChange } from "../lib/consent";

const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const POSTHOG_HOST = "https://us.i.posthog.com";

let initialized = false;

function loadPostHog() {
    if (initialized) return;
    if (typeof window === "undefined") return;
    initialized = true;

    // Standard PostHog snippet, deferred until consent.
    /* eslint-disable */
    !(function (t, e) {
        var o, n, p, r;
        e.__SV ||
            ((window.posthog = e),
            (e._i = []),
            (e.init = function (i, s, a) {
                function g(t, e) {
                    var o = e.split(".");
                    2 == o.length && ((t = t[o[0]]), (e = o[1])),
                        (t[e] = function () {
                            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                        });
                }
                ((p = t.createElement("script")).type = "text/javascript"),
                    (p.crossOrigin = "anonymous"),
                    (p.async = !0),
                    (p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js"),
                    (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
                var u = e;
                for (
                    void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                        u.people = u.people || [],
                        u.toString = function (t) {
                            var e = "posthog";
                            return ("posthog" !== a && (e += "." + a), t || (e += " (stub)"), e);
                        },
                        u.people.toString = function () {
                            return u.toString(1) + ".people (stub)";
                        },
                        o = "init capture identify reset alias group setPersonProperties register unregister opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing".split(" "),
                        n = 0;
                    n < o.length;
                    n++
                )
                    g(u, o[n]);
                e._i.push([i, s, a]);
            }),
            (e.__SV = 1));
    })(document, window.posthog || []);
    /* eslint-enable */

    window.posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: "identified_only",
        // Only enable session recording if user explicitly opted-in to analytics.
        // We keep it on once consent is given because consent already covers it.
        session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
    });
}

function disablePostHog() {
    try {
        if (window.posthog && typeof window.posthog.opt_out_capturing === "function") {
            window.posthog.opt_out_capturing();
        }
    } catch {
        /* ignore */
    }
}

export default function Analytics() {
    useEffect(() => {
        const apply = () => {
            const c = getConsent();
            if (c?.analytics) {
                loadPostHog();
            } else {
                disablePostHog();
            }
        };
        apply();
        const off = onConsentChange(apply);
        return off;
    }, []);

    return null;
}
